export function fmt(min) {
  if (min === undefined || min === null) return "-";
  if (min < 1) return "<1min";
  if (min < 60) return `${Math.round(min)}min`;
  return `${Math.floor(min / 60)}h${Math.round(min % 60)}m`;
}

export function getGradeColor(grade) {
  const colors = {
    "A+": "#10b981", "A": "#10b981",
    "B+": "#22c55e", "B": "#84cc16",
    "C+": "#eab308", "C": "#f59e0b",
    "D": "#f97316", "F": "#ef4444",
  };
  return colors[grade] || "#6b7280";
}

export function getScoreColor(score) {
  if (score >= 80) return "#10b981";
  if (score >= 60) return "#f59e0b";
  return "#ef4444";
}

export function getStatus(score) {
  if (score >= 70) return "good";
  if (score >= 50) return "warning";
  return "bad";
}

export const HOURS = Array.from({ length: 24 }, (_, i) => i);
export const DAYS = ["Seg", "Ter", "Qua", "Qui", "Sex", "Sab", "Dom"];
export const HEATMAP_COLORS = ["#f3f4f6", "#dbeafe", "#93c5fd", "#60a5fa", "#3b82f6", "#2563eb", "#1d4ed8", "#1e40af"];

export function heatColor(val, max) {
  if (!val || !max) return HEATMAP_COLORS[0];
  const idx = Math.min(Math.floor((val / max) * (HEATMAP_COLORS.length - 1)), HEATMAP_COLORS.length - 1);
  return HEATMAP_COLORS[idx];
}
